module.exports = __webpack_public_path__ + "img/nongye.d2ed8475.png";